import { render, staticRenderFns } from "./KullaniciGorevlendirme.vue?vue&type=template&id=7ce70bbd"
import script from "./KullaniciGorevlendirme.vue?vue&type=script&lang=js"
export * from "./KullaniciGorevlendirme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports